import React, { useState, useEffect } from "react";
import { Button, Form, Input, Upload, Space, Flex, Select } from "antd";
import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";

const ThankYouEditor = ({ slide, updateSlide, removeSlide, triggerSave }) => {
  const [groups, setGroups] = useState(slide.thankyouGroup || []);
  const [background, setBackground] = useState(slide.bg || "");
  const [title, setTitle] = useState(slide.title || "Thank You");
  const [subtitle, setSubtitle] = useState(
    slide.subtitle || "Let’s Make Your Next Trip Unforgettable."
  );

  useEffect(() => {
    setGroups(slide.thankyouGroup || []);
    setBackground(slide.bg || "");
    setTitle(slide.title || "Thank You");
    setSubtitle(slide.subtitle || "");
  }, [slide]);

  useEffect(() => {
    updateSlide(slide.id, {
      thankyouGroup: groups,
      bg: background,
      title,
      subtitle,
    });
  }, [triggerSave]);

  const handleBgUpload = (info) => {
    const file = info.file.originFileObj || info.file;
    if (file && file instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => setBackground(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const updateGroup = (idx, key, value) => {
    const next = [...groups];
    next[idx][key] = value;
    setGroups(next);
  };

  const addGroup = () => {
    const newGroup = {
      type: "Meet Us",
      heading: "EFFICIENT TOURISM",
      address: "",
      phoneNumberOne: "",
      phoneNumberTwo: "",
      email: "",
    };
    setGroups([...groups, newGroup]);
  };

  const removeGroup = (idx) => {
    const next = groups.filter((_, i) => i !== idx);
    setGroups(next);
  };

  const renderFields = (g, idx) => {
    switch ((g.type || "").toLowerCase()) {
      case "meet us":
        return (
          <Input
            placeholder="Address"
            value={g.address}
            onChange={(e) => updateGroup(idx, "address", e.target.value)}
          />
        );
      case "call us":
        return (
          <>
            <Input
              placeholder="Phone Number One"
              value={g.phoneNumberOne}
              onChange={(e) =>
                updateGroup(idx, "phoneNumberOne", e.target.value)
              }
            />
            <Input
              placeholder="Phone Number Two"
              value={g.phoneNumberTwo}
              onChange={(e) =>
                updateGroup(idx, "phoneNumberTwo", e.target.value)
              }
            />
          </>
        );
      case "write us":
        return (
          <Input
            placeholder="Email"
            value={g.email}
            onChange={(e) => updateGroup(idx, "email", e.target.value)}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="border p-3 rounded bg-white shadow-sm">
      <h1 className="font-semibold mb-4 text-lg">Edit Thank You Slide</h1>

      <Form layout="vertical">
        {/* Title */}
        <Form.Item label="Title">
          <Input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Thank You"
          />
        </Form.Item>

        <Form.Item label="Subtitle">
          <Input
            value={subtitle}
            onChange={(e) => setSubtitle(e.target.value)}
            placeholder="Let’s Make Your Next Trip Unforgettable."
          />
        </Form.Item>

        <Form.Item label="Thank You Groups">
          {groups.map((g, idx) => (
            <div
              key={idx}
              className="border rounded p-3 mb-3 bg-gray-50"
              style={{ position: "relative" }}
            >
              <Space direction="vertical" style={{ width: "100%" }}>
                <Select
                  value={g.type}
                  options={[
                    { label: "Meet Us", value: "Meet Us" },
                    { label: "Call Us", value: "Call Us" },
                    { label: "Write Us", value: "Write Us" },
                  ]}
                  onChange={(val) => updateGroup(idx, "type", val)}
                />
                <Input
                  placeholder="Heading"
                  value={g.heading}
                  onChange={(e) => updateGroup(idx, "heading", e.target.value)}
                />
                {renderFields(g, idx)}
              </Space>
            </div>
          ))}
        </Form.Item>

        <Flex align="flex-end" justify="space-between">
          <Form.Item className="mb-0" label="Background Image">
            <Upload
              accept="image/*"
              beforeUpload={() => false}
              showUploadList={false}
              onChange={handleBgUpload}
            >
              <button className="mr-2 border px-3 py-1 rounded bg-gray-100">
                <UploadOutlined /> Upload Background
              </button>
            </Upload>

            {background && (
              <img
                src={background}
                alt="Background Preview"
                className="block mt-2 w-full h-32 max-w-xs object-cover rounded-lg border"
              />
            )}
          </Form.Item>

          <Button danger type="primary" onClick={() => removeSlide(slide.id)}>
            <DeleteOutlined /> Remove Slide
          </Button>
        </Flex>
      </Form>
    </div>
  );
};

export default ThankYouEditor;
